import React from 'react';
import { Button } from '@chakra-ui/react';
import { downloadCsv } from '@/utils/download-csv';

interface DownloadButtonProps {
  workspaceId: string;
  actionType: string;
  startDate: string;
  endDate: string;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({
  workspaceId,
  actionType,
  startDate,
  endDate,
}) => {
  const handleDownload = () => {
    downloadCsv(workspaceId, actionType, startDate, endDate);
  };

  return (
    <Button colorPalette='brand' onClick={handleDownload} size={'sm'}>
      Export
    </Button>
  );
};

export default DownloadButton;
